<script setup lang="ts">
import { assertExhaustive } from '@/libs/utilities/assertExhaustive'
import { KollegeUserCourseLessonStatus } from '@/types/schema.generated'
import { computed } from 'vue'

const props = defineProps<{
  status: KollegeUserCourseLessonStatus
}>()

type Status = [label: string, iconClass: string]

const status = computed((): Status => {
  switch (props.status) {
    case KollegeUserCourseLessonStatus.Unbooked:
      return ['受講未予約', 'icon--unbooked']
    case KollegeUserCourseLessonStatus.Booked:
      return ['受講予約済み', 'icon--booked']
    case KollegeUserCourseLessonStatus.Completed:
      return ['受講済', 'icon--completed']
    case KollegeUserCourseLessonStatus.Absented:
      return ['実施なし', 'icon--absented']
    default:
      // KollegeUserCourseLessonStatus.Cancelled について使われなくなる値なので case 節がない
      // すぐ対応される
      //
      // バックエンドから消したらエラーになるのを防ぐために ignore
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      assertExhaustive(props.status)
      return ['', '']
  }
})
</script>
<template>
  <div :class="$style.wrapper">
    <span :class="[$style.icon, $style[status[1]]]">●</span>
    <span :class="$style.text">{{ status[0] }}</span>
  </div>
</template>
<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  font-size: 12px;
  line-height: 1;

  &--unbooked {
    color: $color-label-red;
  }

  &--booked {
    color: $color-label-green;
  }

  &--completed {
    color: $color-label-gray;
  }

  &--absented {
    color: $color-label-gray;
  }
}

.text {
  font-size: 12px;
  line-height: 1;
}
</style>
